import React, { Suspense, useEffect, useState } from "react";
import {
  KernalLogin,
  RootLogin,
  Role,
  Organization,
  Profile,
  Application,
  User,
} from "./views";
import Loading from "./components/Loading";
import {
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import DarkModeContext from "./components/DarkModeContext";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
// import NotFound from "./components/NotFound";
import Header from "./components/Header";
import {
  IconButton,
  ThemeProvider,
  CssBaseline,
  createTheme,
  useMediaQuery,
} from "@mui/material";
import CustomSwitch from "./components/CustomSwitch";
import { removeLoginEncryptedLocalStorage } from "./utils/localStorage";
function App() {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const [darkMode, setDarkMode] = useState(prefersDarkMode);
  const location = useLocation();
  const navigate = useNavigate();
  const roleName = JSON.parse(localStorage.getItem("rbac-data"))?.role_name;
  useEffect(() => {
    const token = localStorage.getItem("token-rbac");
    if (!token) {
      removeLoginEncryptedLocalStorage();
    } 
  }, [navigate]);

  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem("darkMode", newDarkMode);
  };
  const shouldShowIconButton =
    location.pathname === "/" || location.pathname === "/klogin";

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
    },
  });
  return (
    <DarkModeContext.Provider value={{ darkMode, toggleDarkMode }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app-container">
          {shouldShowIconButton && (
            <IconButton
              onClick={toggleDarkMode}
              style={{
                position: "absolute",
                top: "1rem",
                right: "1rem",
                background: darkMode ? "#292F3F" : "#F0F2F5",
                borderRadius: "50%",
                padding: "8px",
                boxShadow: darkMode
                  ? "5px 5px 10px #21262D, -5px -5px 10px #12130F"
                  : "5px 5px 10px #D3D6DB, -5px -5px 10px #ffff",
                transition: "transform 0.2s, background 0.2s",
                // transform: darkMode ? "scale(1)" : "scale(1)",
              }}
            >
              {darkMode ? (
                <WbSunnyIcon style={{ color: "#fff" }} />
              ) : (
                <Brightness4Icon style={{ color: "#12130F" }} />
              )}
            </IconButton>
          )}

          <div style={{ paddingTop: shouldShowIconButton ? "" : "" }}>
            <Suspense fallback={<Loading />}>
              {roleName &&
                location.pathname !== "/" &&
                location.pathname !== "/klogin" && (
                  <Header userRole={roleName} toggleDarkMode={toggleDarkMode} />
                )}
                
              <CustomSwitch>
                <Route
                  path="/klogin"
                  // element={ <PrivateLoginKRoute element={<KernalLogin title="RBAC | KernalLogin" />} />  }
                  element={<KernalLogin title="RBAC | KernalLogin" />}
                />

                <Route
                  path="/"
                  // element={   <PrivateLoginRootRoute element={<RootLogin title="RBAC | RootLogin" />} />  }
                  element={<RootLogin title="RBAC | RootLogin" />}
                />
                {/* <Route path="/*" element={<Navigate to="/login" replace />} /> */}

                <Route
                  path="/profile"
                  element={<Profile title="RBAC | Profile" />}
                />

                {roleName === "KERNAL" && (
                  <>
                    {/* <Route path="/organization" element={ <PrivateKRoute element={<Organization title="RBAC | Organization" />} /> } />
                    <Route path="/application" element={  <PrivateKRoute element={<Application title="RBAC | Application" />} /> } />
                   */}
                    <Route
                      path="/organization"
                      element={<Organization title="RBAC | Organization" />}
                    />
                    <Route
                      path="/application"
                      element={<Application title="RBAC | Application" />}
                    />
                    <Route
                      path="*"
                      element={
                        <Navigate
                          to="/klogin"
                          replace
                          state={{ clearTokenData: true }}
                        />
                      }
                    />
                  </>
                )}
                {roleName === "ROOT" && (
                  <>
                    {/* <Route path="/role" element= { <PrivateRootRoute element={<Role title="RBAC | Role" />} /> } />
                    <Route path="/user" element={ <PrivateRootRoute element={<User title="RBAC | User" />} /> } />
                     */}
                    <Route
                      path="/role"
                      element={<Role title="RBAC | Role" />}
                    />
                    <Route
                      path="/user"
                      element={<User title="RBAC | User" />}
                    />
                    <Route
                      path="*"
                      element={
                        <Navigate
                          to="/"
                          replace
                          state={{ clearTokenData: true }}
                        />
                      }
                    />
                  </>
                )}
                <Route path="*" element={<Navigate to="/" replace />} />
              </CustomSwitch>
            </Suspense>
          </div>
        </div>
      </ThemeProvider>
    </DarkModeContext.Provider>
  );
}

export default App;
